import { useEffect, useRef, useState } from "react";
function useScrollToBottom(threshold = 80) {
    // a ref attached to the scrollable container
    const scrollRef = useRef(null);
    //   whether user is away from the bottom 
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const handleScroll = () => {
            const distFromBottom =
                el.scrollHeight - el.scrollTop - el.clientHeight;

            setShowButton(distFromBottom > threshold);
        };
        handleScroll();
        el.addEventListener("scroll", handleScroll);

        return () => {
            el.removeEventListener("scroll", handleScroll);
        };
    }, [threshold]);

    const scrollToBottom = () => {
        const el = scrollRef.current;
        if (!el) return;
        el.scrollTo({
            top: el.scrollTop + el.clientHeight* 0.8, // ✅ scroll by one visible page
            behavior: "smooth",
        });
    };

    return { scrollRef, showButton, scrollToBottom };
}

export default useScrollToBottom;